import { render } from "./summary-collapsible.vue?vue&type=template&id=7dbc4380&scoped=true&ts=true"
import script from "./summary-collapsible.vue?vue&type=script&lang=ts"
export * from "./summary-collapsible.vue?vue&type=script&lang=ts"

import "./summary-collapsible.vue?vue&type=style&index=0&id=7dbc4380&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbc4380"]])

export default __exports__